import React, { useContext, useEffect, useState } from 'react'
import { BookingContext, SectionHeader } from './NewBooking'
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import PersonIcon from '@mui/icons-material/Person'
import { Button, Card, CardContent, Stack } from '@mui/material'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import PatientLookup from './PatientLookup'
import AddNewPatient from '../NewPatient/AddNewPatient'
import SelectedPatientCard from './SelectedPatientCard'
import BigModal from '../../../components/Modals/BigModal'

const Patient = ({ portalMode = false, portalOrganisation = null }) => {
  const { setFormData, selectedPatient, setSelectedPatient } =
    useContext(BookingContext)
  const [openPatientLookup, setOpenPatientLookup] = useState(false)
  const [openAddNewPatient, setOpenAddNewPatient] = useState(false)
  const [editMode, setEditMode] = useState(false)

  useEffect(() => {
    if (openPatientLookup || openAddNewPatient) {
      setSelectedPatient(null)
      setFormData((prev) => ({ ...prev, patient: null }))
    }
  }, [openAddNewPatient, openPatientLookup])
  return (
    <Box>
      <SectionHeader
        icon={<PersonIcon fontSize="small" />}
        title="Patient Details *"
      />
      {selectedPatient ? (
        <SelectedPatientCard
          patient={selectedPatient}
          portalMode={portalMode}
          onEdit={
            portalMode
              ? null
              : () => {
                  setEditMode(true)
                }
          }
          onRemove={() => {
            setSelectedPatient(null)
            setFormData((prev) => ({
              ...prev,
              patient: null,
            }))
          }}
        />
      ) : (
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            border: '2px dashed',
            borderColor: 'warning.main',
            bgcolor: 'rgba(255, 171, 0, 0.06)',
          }}
        >
          <Stack gap={1.5}>
            <Box>
              <Box component="span" sx={{ fontWeight: 800 }}>
                No patient selected yet.
              </Box>{' '}
              Every booking needs a patient record - look one up or create one
              to get started.
            </Box>
            <Stack direction={{ xs: 'column', lg: 'row' }} gap={1}>
              <Button
                onClick={() => setOpenPatientLookup(true)}
                color="primary"
                variant="contained"
                sx={{ borderRadius: 999 }}
                startIcon={<PersonSearchIcon />}
              >
                Patient Lookup
              </Button>
              <Button
                onClick={() => setOpenAddNewPatient(true)}
                color="anPurple"
                variant="contained"
                sx={{ borderRadius: 999 }}
                startIcon={<PersonAddAlt1Icon />}
              >
                Add a New Patient
              </Button>
            </Stack>
          </Stack>
        </Box>
      )}
      <BigModal
        open={openPatientLookup}
        onClose={() => setOpenPatientLookup(false)}
      >
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            background: 'linear-gradient(135deg, #ffffff 0%, #f9fafc 100%)',
            p: 1,
          }}
        >
          <CardContent>
            <PatientLookup
              setSelectedPatient={setSelectedPatient}
              onClose={() => setOpenPatientLookup(false)}
              createNewPT={() => setOpenAddNewPatient(true)}
              portalMode={portalMode}
              portalOrganisation={portalOrganisation}
            />
          </CardContent>
        </Card>
      </BigModal>
      <AddNewPatient
        open={openAddNewPatient || editMode}
        onClose={() => {
          setOpenAddNewPatient(false)
          setEditMode(false)
        }}
        existingPatient={selectedPatient}
        portalMode={portalMode}
        portalOrganisation={portalOrganisation}
        actionAfterSubmit={(newPatient) => {
          setSelectedPatient(newPatient)
          setFormData((prev) => ({
            ...prev,
            patient: newPatient._id,
          }))
          setOpenAddNewPatient(false)
          setOpenPatientLookup(false)
          setEditMode(false)
        }}
      />
    </Box>
  )
}

export default Patient
